(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDetailController', ShipmentDetailController);

    ShipmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$q', 'previousState', 'entity', 'ShipmentDTOService', 'Invoice', 'RequiredDocument', 'ActivityHistory', 'Lot',
        'CommentCustomService', 'AttachmentCustomService', 'LotCustomService', 'LotMinDTOCustomService', 'ContractCustomService', 'ToastrService', 'PDFExportService',
        '$uibModal', 'InvoiceCustomService', 'XLSXExportService', 'MiscService', 'ShipmentDocumentCustomService','ShipmentDocument','RequiredDocumentCustomService','Principal',
        'FreightPaymentCustomService','ControllerCustomService','ShipmentCustomService'];

    function ShipmentDetailController($scope, $rootScope, $stateParams, $q, previousState, entity, ShipmentDTOService, Invoice, RequiredDocument, ActivityHistory, Lot,
                                      CommentCustomService, AttachmentCustomService, LotCustomService, LotMinDTOCustomService, ContractCustomService, ToastrService, PDFExportService,
                                      $uibModal, InvoiceCustomService, XLSXExportService, MiscService, ShipmentDocumentCustomService, ShipmentDocument, RequiredDocumentCustomService,
                                      Principal, FreightPaymentCustomService, ControllerCustomService, ShipmentCustomService) {
        var vm = this;

        vm.shipment = entity;
        vm.previousState = previousState.name;

        vm.nl2br = MiscService.nl2br;
        vm.convertBoolean = convertBoolean;

        //edit button
        vm.updateShipment = updateShipment;
        //refresh button
        vm.refreshShipmentDetails = refreshShipmentDetails;
        //download pdf button
        vm.downloadPdf = downloadPdf;
        // vm.downloadInvoicePDF = downloadInvoicePDF;
        vm.downloadPurchaseInvoicePDF = downloadPurchaseInvoicePDF;
        vm.downloadSaleInvoicePDF = downloadSaleInvoicePDF;
        vm.downloadDebitNotePDF = downloadDebitNotePDF;
        vm.downloadEditableBOE = downloadEditableBOE;
        vm.downloadEditableBOEApplication = downloadEditableBOEApplication;
        // vm.downloadNContractPDF = downloadNContractPDF;
        //download attachment button
        vm.downloadAttachment = downloadAttachment;
        //preview buttons
        vm.previewExportBill = previewExportBill;
        vm.previewBillOfExchange = previewBillOfExchange;
        //create invoice button
        vm.createPurchaseInvoice = createPurchaseInvoice;
        vm.createSaleInvoice = createSaleInvoice;
        //controller stuff buttons
        vm.addController = addController;
        vm.addControllerNoInvoice = addControllerNoInvoice;
        vm.editController = editController;
        vm.returnControllerValue = returnControllerValue;

        getPrincipal();
        vm.isAgent = false;
        vm.showReqDocs = false;
        function getPrincipal() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.account.company !== null && vm.account.company !== undefined) {
                    if(vm.account.company.id !== undefined) {
                        vm.isAgent = true;
                        vm.agentId = vm.account.company.id;
                        showReqDocsAgent();
                    }
                }
            });
        }
        function showReqDocsAgent() {
            ShipmentCustomService.returnBoolAgentPartOfPurchase(vm.shipment.id).then(function(data) {
                if(data.data === true) {
                    vm.showReqDocs = true;
                }
            }, function(error) {
                ToastrService.error("Something went wrong","Error");
                console.log(JSON.stringify(error));
            });
        }
        //view lot details
        vm.viewLotDetails = function (lot) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-detail-modal.html',
                controller: 'LotDetailModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return lot;
                    }
                }
            }).result.then(function (retVal) {

            });
        };
        vm.setPrecision = setPrecision;

        //placeholders for the lazy stuff
        var shipmentId = vm.shipment.id;
        vm.commentList = [];
        vm.attachmentList = [];
        vm.lotList = [];
        vm.controllerList = [];
        vm.requiredDocument = null;
        vm.lotBaleTotal = 0;
        vm.purchaseInvoices = [];
        vm.saleInvoice = null;

        //ng-show flags
        vm.showComment = false;
        vm.showAttachment = false;
        vm.showLot = false;
        vm.showPurchaseInvoice = false;
        vm.multiplePurchaseInvoice = {
            show: false,
            invoice1: false,
            invoice2: false,
            invoice3: false,
            invoice4: false,
            invoice5: false,
            invoice6: false
        };
        vm.eligibleForInvoice = false;
        vm.showSaleInvoice = false;
        vm.saleInvoiceHasDN = false;

        vm.lots = [];
        vm.invoices = [];
        vm.purchaseInvoices = [];
        vm.saleInvoice = [];
        vm.freightPaymentList = [];
        vm.fpTotalUsd = 0;
        vm.fpTotalEur = 0;

        loadRelatedItems();

        function loadRelatedItems() {
            resolveLots(shipmentId);
            resolveControllers(shipmentId);
            checkInvoices(shipmentId);
            resolveComments( shipmentId );
            resolveAttachments( shipmentId );
            resolveFreightPayments(shipmentId);
            resolveShipmentDocument(shipmentId);
        }

        function resolveLots( id ) {
            LotCustomService.returnMinifiedLotsByShipment( id ).then( function( data ) {
                vm.lotList = data.data;
                vm.showLot = true;
                // if( vm.lotList.length > 0 ) {
                //     ToastrService.success( "Grabbed Lots", "Success" );
                // }
                var promise = [];
                angular.forEach( vm.lotList, function( value, key ) {
                    //set sale stuff
                    if( vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined ) {
                        vm.lotList[key].allocSale = vm.shipment;
                        vm.lotList[key].allocSi = vm.shipment;
                    }
                    //set purchase stuff
                    promise.push(
                        ContractCustomService.returnPurchaseContractByLot( vm.lotList[key].id ).then( function( data ) {
                            vm.lotList[key].purchase = data.data;
                        }, function( error ) {
                            if( error.status !== 404 ) {
                                ToastrService.error( "Failed to get purchase contract of Lot: " + vm.lotList[key].id + " -- " + error.statusText, "Error" );
                            }
                            console.log( error.statusText );
                        })
                    );
                    vm.lotList[key].purchSi = vm.shipment;
                });
                $q.all( promise ).then( function() {
                    countBales();
                });
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot fetch Lots: " + error.statusText, "Error" );
                }
                vm.showLot = false;
                console.log( error.statusText );
            });
        }

        function resolveComments( id ) {
            CommentCustomService.returnCommentsByShipment( id ).then( function( data ) {
                vm.commentList = data.data;
                // if( vm.commentList.length > 0 ) {
                //     ToastrService.success( "Fetched comments", "Success!" );
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Failed to fetch comments: " + error.statusText, "Error" );
                }
            });
        }

        function resolveAttachments( id ) {
            AttachmentCustomService.returnAttachmentsByShipment( id ).then( function( data ) {
                vm.attachmentList = data.data;
                // if( vm.attachmentList.length > 0 ) {
                //     ToastrService.success( "Fetched Attachments", "Success!" );
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Failed to fetch Attachments: " + error.statusText, "Error" );
                }
            });
        }

        function resolveFreightPayments(id) {
            vm.freightPaymentList = [];
            FreightPaymentCustomService.returnFreightPaymentsByShipment(id).then(function(data) {
                vm.freightPaymentList = data.data;
                getFpTotals();
            }, function(error) {
                ToastrService.error("Failed to fetch Freight Payments: " + error.statusText, "Error");
            });
        }

        function getFpTotals() {
            vm.fpTotalUsd = 0;
            vm.fpTotalEur = 0;
            if(vm.freightPaymentList.length > 0) {
                angular.forEach(vm.freightPaymentList, function(value, key) {
                    if(value.invoiceCurrency === "USD") {
                        vm.fpTotalUsd += value.invoiceAmount;
                    } else {
                        vm.fpTotalEur += value.invoiceAmount;
                    }
                });
            }
        }

        function resolveShipmentDocument(id) {
            ShipmentDocumentCustomService.getShipmentDocumentByShipmentId(id).then(function(data) {
                vm.shipmentDocument = data.data;
                resolveRequiredDocuments();
            }, function(error) {
                vm.shipmentDocument = null;
                ToastrService.error("Failed to get Shipment Document","Error");
            });
        }

        function resolveRequiredDocuments() {
            vm.requiredDocuments = {
                purchaseInvoice: {},
                saleInvoice: {},
                icInvoice: {},
                bl: {},
                pl: {},
                wc: {},
                co: {},
                phyto: {},
                wr: {},
                ic: {},
                sc: {},
                fumigation: {}
            }
            if(vm.shipmentDocument.purchaseInvoice) {
                fetchRequiredDocument(vm.shipmentDocument.id, "PURCHASEINVOICE");
            }
            if(vm.shipmentDocument.saleInvoice) {
                fetchRequiredDocument(vm.shipmentDocument.id, "SALEINVOICE");
            }
            if(vm.shipmentDocument.icInvoice) {
                fetchRequiredDocument(vm.shipmentDocument.id, "ICINVOICE");
            }
            if(vm.shipmentDocument.bl) {
                fetchRequiredDocument(vm.shipmentDocument.id, "BL");
            }
            if(vm.shipmentDocument.pl) {
                fetchRequiredDocument(vm.shipmentDocument.id, "PL");
            }
            if(vm.shipmentDocument.wc) {
                fetchRequiredDocument(vm.shipmentDocument.id, "WC");
            }
            if(vm.shipmentDocument.co) {
                fetchRequiredDocument(vm.shipmentDocument.id, "CO");
            }
            if(vm.shipmentDocument.phyto) {
                fetchRequiredDocument(vm.shipmentDocument.id, "PHYTO");
            }
            if(vm.shipmentDocument.wr) {
                fetchRequiredDocument(vm.shipmentDocument.id, "WR");
            }
            if(vm.shipmentDocument.ic) {
                fetchRequiredDocument(vm.shipmentDocument.id, "IC");
            }
            if(vm.shipmentDocument.sc) {
                fetchRequiredDocument(vm.shipmentDocument.id, "SC");
            }
            if(vm.shipmentDocument.fumigation) {
                fetchRequiredDocument(vm.shipmentDocument.id, "FUMIGATION");
            }
        }

        function fetchRequiredDocument(id, type) {
            RequiredDocumentCustomService.getRequiredDocumentByShipmentDocumentIdAndType(id, type).then(function(data) {
                applyRequiredDocument(data.data, type);
            }, function(error) {
                ToastrService.error("Failed to fetch Required Document for type: " + type, "Error!");
            });
        }

        function applyRequiredDocument(value, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice = value;
                    vm.requiredDocuments.purchaseInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.purchaseInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice = value;
                    vm.requiredDocuments.saleInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.saleInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.saleInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.saleInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice = value;
                    vm.requiredDocuments.icInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.icInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.icInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.icInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'BL':
                    vm.requiredDocuments.bl = value;
                    vm.requiredDocuments.bl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, true).then(function(data) {
                        vm.requiredDocuments.bl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.bl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, false).then(function(data) {
                        vm.requiredDocuments.bl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PL':
                    vm.requiredDocuments.pl = value;
                    vm.requiredDocuments.pl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, true).then(function(data) {
                        vm.requiredDocuments.pl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.pl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, false).then(function(data) {
                        vm.requiredDocuments.pl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WC':
                    vm.requiredDocuments.wc = value;
                    vm.requiredDocuments.wc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, true).then(function(data) {
                        vm.requiredDocuments.wc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, false).then(function(data) {
                        vm.requiredDocuments.wc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'CO':
                    vm.requiredDocuments.co = value;
                    vm.requiredDocuments.co.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, true).then(function(data) {
                        vm.requiredDocuments.co.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Final Attachment", "Error");
                    });
                    vm.requiredDocuments.co.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, false).then(function(data) {
                        vm.requiredDocuments.co.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto = value;
                    vm.requiredDocuments.phyto.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, true).then(function(data) {
                        vm.requiredDocuments.phyto.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Final Attachment", "Error");
                    });
                    vm.requiredDocuments.phyto.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, false).then(function(data) {
                        vm.requiredDocuments.phyto.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WR':
                    vm.requiredDocuments.wr = value;
                    vm.requiredDocuments.wr.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, true).then(function(data) {
                        vm.requiredDocuments.wr.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wr.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, false).then(function(data) {
                        vm.requiredDocuments.wr.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'IC':
                    vm.requiredDocuments.ic = value;
                    vm.requiredDocuments.ic.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, true).then(function(data) {
                        vm.requiredDocuments.ic.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.ic.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, false).then(function(data) {
                        vm.requiredDocuments.ic.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SC':
                    vm.requiredDocuments.sc = value;
                    vm.requiredDocuments.sc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, true).then(function(data) {
                        vm.requiredDocuments.sc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.sc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, false).then(function(data) {
                        vm.requiredDocuments.sc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation = value;
                    vm.requiredDocuments.fumigation.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, true).then(function(data) {
                        vm.requiredDocuments.fumigation.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Final Attachment", "Error");
                    });
                    vm.requiredDocuments.fumigation.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, false).then(function(data) {
                        vm.requiredDocuments.fumigation.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
            }
        }

        function resolveCommentsRequiredDocument(type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.purchaseInvoice.id).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Comments", "Error");
                    });
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.saleInvoice.id).then(function(data) {
                        vm.requiredDocuments.saleInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Comments", "Error");
                    });
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.icInvoice.id).then(function(data) {
                        vm.requiredDocuments.icInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Comments", "Error");
                    });
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.bl.id).then(function(data) {
                        vm.requiredDocuments.bl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Comments", "Error");
                    });
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.pl.id).then(function(data) {
                        vm.requiredDocuments.pl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Comments", "Error");
                    });
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wc.id).then(function(data) {
                        vm.requiredDocuments.wc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Comments", "Error");
                    });
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.co.id).then(function(data) {
                        vm.requiredDocuments.co.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Comments", "Error");
                    });
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.phyto.id).then(function(data) {
                        vm.requiredDocuments.phyto.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Comments", "Error");
                    });
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wr.id).then(function(data) {
                        vm.requiredDocuments.wr.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Comments", "Error");
                    });
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.ic.id).then(function(data) {
                        vm.requiredDocuments.ic.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Comments", "Error");
                    });
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.sc.id).then(function(data) {
                        vm.requiredDocuments.sc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Comments", "Error");
                    });
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.fumigation.id).then(function(data) {
                        vm.requiredDocuments.fumigation.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Comments", "Error");
                    });
                    break;
            }
        }

        function countBales() {
            vm.totalBales = 0;
            vm.totalWeight = 0;
            vm.contractABal = 0;
            vm.contractBBal = 0;
            vm.contractCBal = 0;
            vm.contractDBal = 0;
            vm.contractEBal = 0;
            vm.contractFBal = 0;
            vm.totalKgs = 0;
            vm.totalLbs = 0;
            vm.totalMTs = 0;
            angular.forEach(vm.lotList, function (value, key) {
                if (vm.shipment.contractAId != null && vm.shipment.contractAId !== undefined && vm.shipment.contractAId === value.purchase.id) {
                    vm.contractABal += returnMyValue( value );
                }
                if (vm.shipment.contractBId != null && vm.shipment.contractBId !== undefined && vm.shipment.contractBId === value.purchase.id) {
                    vm.contractBBal += returnMyValue( value );
                }
                if (vm.shipment.contractCId != null && vm.shipment.contractCId !== undefined && vm.shipment.contractCId === value.purchase.id) {
                    vm.contractCBal += returnMyValue( value );
                }
                if(vm.shipment.contractDId != null && vm.shipment.contractDId !== undefined && vm.shipment.contractDId === value.purchase.id) {
                    vm.contractDBal += returnMyValue(value);
                }
                if(vm.shipment.contractEId != null && vm.shipment.contractEId !== undefined && vm.shipment.contractEId === value.purchase.id) {
                    vm.contractEBal += returnMyValue(value);
                }
                if(vm.shipment.contractFId != null && vm.shipment.contractFId !== undefined && vm.shipment.contractFId === value.purchase.id) {
                    vm.contractFBal += returnMyValue(value);
                }
                vm.totalBales += parseInt(value.qtyBales);
                vm.totalWeight += returnMyValue( value );
                vm.totalKgs += returnSpecificValue( value, "KGS" );
                vm.totalLbs += returnSpecificValue( value, "LBS" );
                vm.totalMTs += returnSpecificValue( value, "MTS" );
            });
        }

        function returnMyValue( value ) {
            if( vm.shipment.shipmentQtyUnitType !== undefined && vm.shipment.shipmentQtyUnitType !== null ) {
                switch( vm.shipment.shipmentQtyUnitType ) {
                    case 'KGS':
                        // return setPrecision( value.purchLandedNetKgs, 3 );
                        return value.purchLandedNetKgs;
                        break;
                    case 'LBS':
                        // return setPrecision( value.purchLandedNetLbs, 3 );
                        return value.purchLandedNetLbs;
                        break;
                    case 'MTS':
                        // return setPrecision( value.purchLandedNetMTs, 3 );
                        return value.purchLandedNetMTs;
                        break;
                    default:
                        return value.qtyBales;
                        break;
                }
            } else {
                return 0;
            }
        }

        function returnSpecificValue( value, qtyUnitType ) {
            switch( qtyUnitType ) {
                case 'KGS':
                    return value.purchLandedNetKgs;
                    break;
                case 'LBS':
                    return value.purchLandedNetLbs;
                    break;
                case 'MTS':
                    return value.purchLandedNetMTs;
                    break;
                default:
                    return 0;
                    break;
            }
        }

        function checkEligibleForInvoice( length ) {
            vm.contractIds = [];
            if( vm.shipment.contractAId !== null ) {
                vm.contractIds.push( vm.shipment.contractAId );
            }
            if( vm.shipment.contractBId !== null ) {
                vm.contractIds.push( vm.shipment.contractBId );
            }
            if( vm.shipment.contractCId !== null ) {
                vm.contractIds.push( vm.shipment.contractCId );
            }
            if(vm.shipment.contractDId !== null) {
                vm.contractIds.push(vm.shipment.contractDId);
            }
            if(vm.shipment.contractEId !== null) {
                vm.contractIds.push(vm.shipment.contractEId);
            }
            if(vm.shipment.contractFId !== null) {
                vm.contractIds.push(vm.shipment.contractFId);
            }
            vm.eligibleForInvoice = vm.contractIds.length > length;
        }

        function checkInvoices( id ) {
            // InvoiceCustomService.returnInvoiceByShipmentAndType(id, "PURCHASE").then(function (data) {
            InvoiceCustomService.returnMinifiedInvoiceByShipmentAndType(id, "PURCHASE").then(function (data) {
                vm.purchaseInvoices = data.data;
                if (vm.purchaseInvoices.length > 0) {
                    checkEligibleForInvoice( vm.purchaseInvoices.length );
                    if (vm.purchaseInvoices.length > 1) { //multiple invoice
                        vm.showPurchaseInvoice = false;
                        vm.multiplePurchaseInvoice.show = true;
                        angular.forEach(vm.purchaseInvoices, function (value, key) {
                            showPurchaseInvoiceKey(key);
                            vm.purchaseInvoices[key].controllers = [];
                            ControllerCustomService.getControllersByShipmentAndInvoice(id, vm.purchaseInvoices[key].id).then(function(data) {
                                vm.purchaseInvoices[key].controllers = data.data;
                            }, function(error) {
                                if(error.status !== 404) {
                                    ToastrService.error("Cannot fetch Controllers for Invoice: " + vm.purchaseInvoices[key].invNum + " " + error.statusText,"Error");
                                }
                            });
                            if (vm.purchaseInvoices[key].commissionRate !== undefined && vm.purchaseInvoices[key].commissionRate !== null) {
                                vm.purchaseInvoices[key]['purchaseInvoiceHasDn'] = true;
                            } else {
                                vm.purchaseInvoices[key]['purchaseInvoiceHasDn'] = false;
                            }
                        });
                    } else { //there's only one invoice
                        vm.showPurchaseInvoice = true;
                        vm.multiplePurchaseInvoice.show = false;
                        vm.multiplePurchaseInvoice.invoice1 = false;
                        vm.multiplePurchaseInvoice.invoice2 = false;
                        vm.multiplePurchaseInvoice.invoice3 = false;
                        vm.multiplePurchaseInvoice.invoice4 = false;
                        vm.multiplePurchaseInvoice.invoice5 = false;
                        vm.multiplePurchaseInvoice.invoice6 = false;
                        vm.purchaseInvoices[0].controllers = [];
                        ControllerCustomService.getControllersByShipmentAndInvoice(id, vm.purchaseInvoices[0].id).then(function(data) {
                            vm.purchaseInvoices[0].controllers = data.data;
                        }, function(error) {
                            if(error.status !== 404) {
                                ToastrService.error("Cannot fetch Controllers for Invoice: " + vm.purchaseInvoices[0].invNum + " " + error.statusText,"Error");
                            }
                        });
                        if (vm.purchaseInvoices[0].commissionRate !== undefined && vm.purchaseInvoices[0].commissionRate !== null) {
                            vm.purchaseInvoices[0]['purchaseInvoiceHasDn'] = true;
                        } else {
                            vm.purchaseInvoices[0]['purchaseInvoiceHasDn'] = false;
                        }
                    }
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Cannot fetch Purchase Invoice: " + error.statusText, "Error");
                }
                vm.showPurchaseInvoice = false;
                vm.multiplePurchaseInvoice.show = false;
                vm.multiplePurchaseInvoice.invoice1 = false;
                vm.multiplePurchaseInvoice.invoice2 = false;
                vm.multiplePurchaseInvoice.invoice3 = false;
                vm.multiplePurchaseInvoice.invoice4 = false;
                vm.multiplePurchaseInvoice.invoice5 = false;
                vm.multiplePurchaseInvoice.invoice6 = false;
                console.log(error.statusText);
            });
            // InvoiceCustomService.returnInvoiceByShipmentAndType(id, "SALE,JAPAN").then(function (data) {
            InvoiceCustomService.returnMinifiedInvoiceByShipmentAndType(id, "SALE,JAPAN").then(function (data) {
                vm.saleInvoice = data.data;
                if (vm.saleInvoice.length > 0) {
                    if (vm.saleInvoice[0].invNum !== undefined) {
                        vm.showSaleInvoice = true;
                        vm.saleInvoice.controllers = [];
                        ControllerCustomService.getControllersByShipmentAndInvoice(id, vm.saleInvoice[0].id).then(function(data) {
                            vm.saleInvoice[0].controllers = data.data;
                        }, function(error) {
                            if(error.status !== 404) {
                                ToastrService.error("Cannot fetch Controllers for Sale Invoice: " + vm.saleInvoice[0].invNum + " " + error.statusText,"Error");
                            }
                        });
                        if (vm.saleInvoice[0].commissionRate !== undefined && vm.saleInvoice[0].commissionRate !== null) {
                            vm.saleInvoiceHasDN = true;
                        } else {
                            vm.saleInvoiceHasDN = false;
                        }
                    }
                } else {
                    vm.showSaleInvoice = false;
                    vm.saleInvoiceHasDN = false;
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Cannot fetch Sale Invoice: " + error.statusText, "Error");
                }
                vm.showSaleInvoice = false;
                vm.saleInvoiceHasDN = false;
                console.log(error.statusText);
            });
        }

        function resolveControllers(id) {
            ControllerCustomService.getControllersByShipment(id).then(function(data) {
                vm.controllerList = data.data;
                if(vm.controllerList.length > 0) {
                    // ToastrService.success("Grabbed Controllers","Success");
                    computeControllerValues();
                }
            }, function(error) {
                if(error.status !== 404) {
                    ToastrService.error("Cannot fetch Controllers: " + error.statusText, "Error");
                }
                console.log(error.statusText);
            });
        }

        function computeControllerValues() {
            vm.controllerTotals = {
                amountUSD: 0,
                balanceUSD: 0,
                amountEUR: 0,
                balanceEUR: 0
            };
            angular.forEach(vm.controllerList, function(value, key) {
                if(value.currency === "USD") {
                    vm.controllerTotals.amountUSD += value.amount;
                    vm.controllerTotals.balanceUSD += value.balance;
                } else {
                    vm.controllerTotals.amountEUR += value.amount;
                    vm.controllerTotals.balanceEUR += value.balance;
                }
            });
        }

        function returnControllerValue(controller, field, currency) {
            switch(field) {
                case 'amount':
                    return controller.currency === currency ? setPrecision(controller.amount, 2) : setPrecision(0,2);
                    break;
                case 'balance':
                    return controller.currency === currency ? setPrecision(controller.balance, 2) : setPrecision(0,2);
                    break;
                default:
                    return setPrecision(0, 2);
                    break;
            }
        }

        function addController(invoiceId, invNum) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            controller: null,
                            amount: 0,
                            balance: 0,
                            currency: 'USD',
                            amountDisplay: null,
                            shipment: {
                                id: shipmentId,
                                siNum: vm.shipment.shipmentSiNum
                            },
                            invoice: {
                                id: invoiceId,
                                invNum: invNum
                            }
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                checkInvoices(shipmentId);
                resolveControllers(shipmentId);
            });
        }

        function addControllerNoInvoice() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            controller: null,
                            amount: 0,
                            balance: 0,
                            currency: 'USD',
                            amountDisplay: null,
                            shipment: {
                                id: shipmentId,
                                siNum: vm.shipment.shipmentSiNum
                            },
                            invoice: null
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                checkInvoices(shipmentId);
                resolveControllers(shipmentId);
            });
        }

        function editController(controller) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return controller;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                checkInvoices(shipmentId);
                resolveControllers(shipmentId);
            });
        }

        function showPurchaseInvoiceKey( key ) {
            switch( key ) {
                case 0:
                    vm.multiplePurchaseInvoice.invoice1 = true;
                    break;
                case 1:
                    vm.multiplePurchaseInvoice.invoice2 = true;
                    break;
                case 2:
                    vm.multiplePurchaseInvoice.invoice3 = true;
                    break;
                case 3:
                    vm.multiplePurchaseInvoice.invoice4 = true;
                    break;
                case 4:
                    vm.multiplePurchaseInvoice.invoice5 = true;
                    break;
                case 5:
                    vm.multiplePurchaseInvoice.invoice6 = true;
                    break;
            }
        }

        function createPurchaseInvoice() {
            var data = {
                heading: 'Create Invoice',
                route: 'invoice-purchase.new',
                id: shipmentId,
                param: { shipmentId: shipmentId }
            };
            $rootScope.$emit( 'handleEmit', data );
        }

        function createSaleInvoice() {
            var data = {
                heading: 'Create Sale Invoice',
                route: 'invoice-sale.new',
                id: shipmentId,
                param: { shipmentId: shipmentId }
            };
            $rootScope.$emit( 'handleEmit', data );
        }

        function updateShipment() {
            var data = {
                heading: 'Edit ' + vm.shipment.shipmentSiNum,
                route: 'shipment.edit',
                id: vm.shipment.id,
                param: {id: ''}
            };
            $rootScope.$emit('handleEmit', data);
        }

        function refreshShipmentDetails() {
            vm.shipment = refetchShipment(shipmentId);
            loadRelatedItems();
        }

        function downloadPdf() {
            PDFExportService.downloadShipmentPDF(vm.shipment.id).then(function (data, status, headers, config) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, vm.shipment.shipmentSiNum + '.pdf');
            }, function (error) {
                ToastrService.error("Something went wrong", "Error!");
            });
        }

        function downloadPurchaseInvoicePDF(invoice) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-purchase.html',
                controller: 'DownloadPurchaseInvoicePDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function(res) {
                PDFExportService.downloadInvoicePDF(invoice.id, invoice.invType, true, true, true, true, true, true, true, res.showLotWeights === 'Show').then(function(data, status, headers, config) {
                    var file = new Blob([data.data],{type:'application/pdf'});
                    saveAs(file, vm.shipment.shipmentSiNum + '-invoice.pdf');
                }, function(error) {
                    ToastrService.error("Cannot download Purchase Invoice PDF", "Error");
                    console.log(error.statusText);
                });
            });
        }

        function downloadSaleInvoicePDF(invoice) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-ncontractpdf.html',
                controller: 'DownloadNContractPDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function(res) {
                PDFExportService.downloadInvoicePDF(invoice.id, invoice.invType, res.showVessel === 'Show', res.showVoyageDetails === 'Show', res.showContract === 'Show',
                    res.showLot === 'Show', res.showLCDetails === 'Show', res.showController === 'Show', res.showPaymentTenor === 'Show', res.showLotWeights === 'Show').then(function(data, status, headers, config) {
                    var file = new Blob([data.data],{type:'application/pdf'});
                    saveAs(file, vm.shipment.shipmentSiNum + '-invoice.pdf');
                }, function(error) {
                    ToastrService.error("Cannot download Sale Invoice PDF", "Error");
                    console.log(error.statusText);
                });
            });
        }

        function downloadEditableBOE() {
            XLSXExportService.downloadShipmentBoeXLSX( vm.shipment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                saveAs( file, vm.shipment.shipmentSiNum + ".xls" );
            }, function( error ) {
                ToastrService.error("Couldn't download Bill of Exchange");
            });
        }

        function downloadEditableBOEApplication( negotiation ) {
            if(negotiation) {
                XLSXExportService.downloadShipmentBoeApplicationXLSX( vm.shipment.id, negotiation, false, false ).then( function(data) {
                    var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    saveAs( file, vm.shipment.shipmentSiNum + ' - Application for Negotiation.xls' );
                }, function(error) {
                    ToastrService.error("Something went wrong", "Error!");
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/shipment/dialog/shipment-application-immediate-credit-download.html',
                    controller: 'ShipmentApplicationImmediateCreditDownloadController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(res) {
                    XLSXExportService.downloadShipmentBoeApplicationXLSX(vm.shipment.id, negotiation, res.insurance === "CIF", res.obl === "OBL").then(function(data) {
                        var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                        saveAs(file, vm.shipment.shipmentSiNum + ' - Application for Immediate Credit.xls');
                    }, function(error) {
                        ToastrService.error("Something went wrong", "Error!");
                    });
                });
            }
        }

        function downloadDebitNotePDF(invoice) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-dnpdf.html',
                controller: 'DownloadDebitNotePDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function(res) {
                PDFExportService.downloadDebitNotePDF(invoice.id, res === 'show').then(function (data, status, headers, config) {
                    var file = new Blob([data.data], {type: 'application/pdf'});
                    saveAs(file, "DN-" + invoice.invNum + ".pdf");
                }, function (error) {
                    ToastrService.error("Cannot download Purchase Debit Note PDF", "Error");
                    console.log(error.statusText);
                });
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot download Attachment: " + error.statusText, "Error");
                }
            });
        }

        function previewExportBill() {
            $uibModal.open({
                templateUrl: 'app/entities/shipment/shipment-exportBill-preview.modal.html',
                controller: 'ShipmentExportBillPreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return vm.shipment;
                    }
                }
            }).result.then();
        }

        function previewBillOfExchange() {
            $uibModal.open({
                templateUrl: 'app/entities/shipment/shipment-boe-preview.modal.html',
                controller: 'ShipmentBoePreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return vm.shipment;
                    }
                }
            }).result.then();
        }

        function refetchShipment(id) {
            return ShipmentDTOService.get({id: id});
        }

        var unsubscribe = $rootScope.$on('ccsTrApp:shipmentUpdate', function (event, result) {
            vm.shipment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };

        function setPrecision(originalValue, scale) {
            return parseFloat(originalValue).toFixed(scale);
        }

        function convertBoolean(value) {
            return value === true ? 'Required' : 'Not Required';
        }
    }
})();
